import React from 'react'
import BaseButton from 'shared/components/button/components/base-button'
import { ButtonType } from 'shared/components/button/types/button-interface'

const LightButton = (props: ButtonType) => (
  <BaseButton
    color={'text-text-primary/50'}
    hoverColor={'hover:text-background-secondary'}
    backgroundColor={'bg-background-primary'}
    hoverBackgroundColor={'hover:bg-background-primary'}
    {...props}
  />
)
export default LightButton
